import { AxiosProgressEvent } from 'axios'
import {
  fetchPresignedURLMultiUpload,
  fetchPresignedURLSingleUpload,
  presignedURLSingleUploadPutCall,
} from '../apis/fetchPresignedUrl.api'
import { MULTI_UPLOAD_UTILS } from './strings'
import { ToasterTypeValues } from '../types/common'
import { MODE_CONSTANTS } from './constants'
import { getUploadApiErrorMessage, NAMESPACE } from '@ui-kit'

export const handleFileChange = async (
  e: React.ChangeEvent<HTMLInputElement>,
  d_entity_id: number | undefined,
  field_id: number | undefined | null
) => {
  if (e.target.files?.length) {
    const selectedFile = e.target.files[0]
    try {
      const payload = {
        name: selectedFile?.name,
        entity_id: d_entity_id ?? 0,
        content_type: selectedFile?.type,
        size: selectedFile?.size,
        field_id: field_id ?? 0,
      }
      const response = await fetchPresignedURLSingleUpload(payload)
      presignedURLSingleUploadPutCall(
        response?.data?.pre_signed_url,
        selectedFile,
        undefined,
        undefined,
        response?.data?.tagging ?? undefined,
        response?.data?.DOCUMENT_IDENTIFIER ?? undefined,
        response?.data?.meta_data?.UPLOAD_CHANNEL ?? undefined,
        response?.data?.meta_data?.UPLOAD_IDENTIFIER ?? undefined
      )
      return response
    } catch (error) {
      console.error(MULTI_UPLOAD_UTILS.API_ERROR_MESSAGE, error)
    }
  }
}
const getIndex = (
  mode: (typeof MODE_CONSTANTS)[keyof typeof MODE_CONSTANTS],
  count: number,
  index: number
) => {
  return mode === 'edit' ? count : index
}
const getIndexForPresignedURLSingleUploadPutCall = (
  mode: (typeof MODE_CONSTANTS)[keyof typeof MODE_CONSTANTS],
  count: number,
  index: number
) => {
  return mode === 'edit' || mode === 'view' ? count : index
}

export const handleFileChangeMultiUpload = async ({
  files,
  field_id,
  entityId,
  onProgress,
  documentId,
  handleToaster,
  mode,
  filesLength,
}: {
  files: File[]
  field_id: number
  entityId: number
  onProgress: (val: AxiosProgressEvent, index?: number) => void
  documentId: number | null
  handleToaster: (message: string, type: ToasterTypeValues) => void
  mode: (typeof MODE_CONSTANTS)[keyof typeof MODE_CONSTANTS]
  filesLength: number
}) => {
  if (files?.length) {
    const selectedFiles = files
    try {
      const payload = [...selectedFiles]?.map((val: File) => {
        return {
          name: val?.name,
          entity_id: entityId,
          content_type: val?.type,
          size: val?.size,
          field_id: field_id,
          type: MULTI_UPLOAD_UTILS.ENTITY_NAME,
        }
      })
      const response = await fetchPresignedURLMultiUpload(payload, documentId)
      let count = 0
      let filesCount = filesLength
      let uploadedCount = 0
      let attemptedCount = 0
      for (let index = 0; index < response?.data?.attachment?.length; index++) {
        if (
          response?.data?.attachment?.[index]?.url &&
          response?.data?.attachment?.[index]?.type !== 'document' &&
          response?.data?.attachment?.[index]?.description !== 'cover_sheet'
        ) {
          attemptedCount++
          const result = await presignedURLSingleUploadPutCall(
            response?.data?.attachment[index]?.url,
            selectedFiles[count],
            onProgress,
            getIndexForPresignedURLSingleUploadPutCall(mode, filesCount, index),
            response?.data?.attachment?.[index]?.tagging ?? undefined,
            response?.data?.attachment?.[index]?.meta_data
              ?.DOCUMENT_IDENTIFIER ?? undefined,
            response?.data?.attachment?.[index]?.meta_data?.UPLOAD_CHANNEL ??
              undefined,
            response?.data?.attachment?.[index]?.meta_data?.UPLOAD_IDENTIFIER ??
              undefined
          )

          if (result.status === 200) {
            uploadedCount++
            onProgress(
              {
                progress: 1,
                loaded: 0,
                bytes: 0,
                lengthComputable: false,
              },
              getIndex(mode, filesCount, index)
            )
          }
          filesCount++
          count++
        }
      }
      if (
        attemptedCount !== selectedFiles.length ||
        uploadedCount !== selectedFiles.length
      ) {
        return null
      }
      return response?.data?.id
    } catch (error) {
      handleToaster(
        getUploadApiErrorMessage(error, NAMESPACE.UPLOAD_API_ERROR),
        'error'
      )
      console.error(MULTI_UPLOAD_UTILS.API_ERROR_MESSAGE, error)
      return null
    }
  }
}
